// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./slideshow_blue.png");
var dir = previousRequest.replace("slideshow_blue.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "slideshow_blue.png",
	name: "slideshow_blue",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/slideshow_blue.png
// module id = 1111
// module chunks = 4